import { errorInput } from 'src/components/helpers';
import { reportTypes, crecerSteps, seminaryEvent } from 'src/containers/crecer/crecerShared';
import { crecerStepToEvent } from './constants';

export function getDefaultInputs() {
  return {
    identification: '',
    phone: '',
    whoSentTheLink: '',
    type: reportTypes[0]?.value ?? 'crecer',
    step: crecerSteps[0]?.value ?? 'encuentro',
    seminary: seminaryEvent[0]?.value ?? 'ParaSiempre',
  };
}

export function getCurrentEvent(inputs) {
  if (inputs.type === 'crecer') return crecerStepToEvent[inputs.step] || null;
  if (inputs.type === 'seminarios') return inputs.seminary || null;
  return null;
}

export function getStepsMadeForEvent(guest, inputs, currentEvent) {
  if (!guest) return null;
  if (inputs.type === 'crecer') {
    const map = {
      crecerConectar: guest.CrecerConectarSteps,
      crecerEncuentro: guest.CrecerEncuentroSteps,
      crecerVida: guest.CrecerVidaSteps,
      crecerInfluence: guest.CrecerInfluenceSteps,
      crecerBautizo: guest.CrecerBaptismSteps,
    };
    return map[currentEvent] ?? null;
  }
  if (inputs.type === 'seminarios') {
    const sem = guest.Seminaries?.find((s) => s.seminary === currentEvent);
    return sem ? [sem] : null;
  }
  return null;
}

export function getDatesForEvent(crecerDates, currentEvent) {
  if (!currentEvent) return [];
  return crecerDates.filter((d) => d.event === currentEvent);
}

export function getSelectedCodesList(selectedAttendanceCodes) {
  return Object.entries(selectedAttendanceCodes)
    .filter(([, checked]) => checked)
    .map(([code]) => code);
}

export function hasAttendanceForDate(stepsMadeForEvent, date) {
  const content = stepsMadeForEvent?.[0];
  if (!content) return false;
  return !!content[date.attendanceCode];
}

/**
 * Builds login validation errors. Returns { errorInputs, hasErrors }.
 */
export function buildLoginErrorInputs(inputs) {
  const mandatory = ['identification', 'phone', 'whoSentTheLink'];
  let errorInputs = {};
  mandatory.forEach((name) => {
    errorInputs = errorInput({
      errorInputs,
      input: { name, value: inputs[name] },
    });
  });
  if (inputs.identification && inputs.identification.length <= 5) {
    errorInputs = errorInput({
      errorInputs,
      input: { name: 'identification', value: inputs.identification.length >= 5 },
    });
  }
  const hasErrors = Object.values(errorInputs).some(Boolean);
  return { errorInputs, hasErrors };
}
